<div class="container">
	<div class="overlay-bg"></div>
	<div class="mid-content">
		@if (form) {
			<div
				class="p-relative form-container"
				style="
					margin-right: 1px;
					border-top-left-radius: 25px;
					border-bottom-left-radius: 25px;
					background-color: white;
				">
				<div @fadeAndSlideUp>
					<form novalidate [formGroup]="form" (submit)="renew(form.value)">
						<p-card class="nice-border" styleClass="ui-card-shadow">
							<div class="ui-g login-block p-1">
								<div class="ui-g-12 ui-lg-12 p-0">
									<div class="text-center">
										<img src="./assets/img/smartyCubes-logo.png" alt="SmartyCube" />
									</div>
								</div>
								<div class="ui-lg-12 ui-g-12 hr"></div>
								<div class="ui-lg-12 ui-md-12 ui-g-12">
									<label>
										<b>{{ 'login.old-password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.old-password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="oldPassword"
										formControlName="oldPassword"
										required />
									<sis-validation-summary
										[form]="form"
										[name]="'oldPassword'"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12">
									<label>
										<b>{{ 'login.new-password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.new-password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="newPassword"
										formControlName="newPassword" />
									<sis-validation-summary
										[form]="form"
										name="newPassword"
										[visible]="invalidForm"></sis-validation-summary>
								</div>
								<div class="ui-lg-12 ui-md-12 ui-g-12 pb-2">
									<label>
										<b>{{ 'login.confirm-password' | translate }}</b>
									</label>
									<input
										placeholder="{{ 'login.confirm-password' | translate }}"
										type="password"
										class="w-100"
										pPassword
										[feedback]="false"
										name="confirmPassword"
										formControlName="confirmPassword" />
									<sis-validation-summary [form]="form" [visible]="invalidForm"></sis-validation-summary>
								</div>
								<ng-template #footer>
									<div class="ui-lg-12 login-border text-right">
										<button
											pButton
											type="button"
											[routerLink]="'/login'"
											icon="fas fa-home"
											label="{{ 'login.back' | translate }}"
											class="action-btn btn-color ui-dark-button"></button>
										<button
											pButton
											type="submit"
											label="{{ 'login.create-password' | translate }}"
											[disabled]="form.invalid"
											icon="fas fa-unlock-alt"
											class="action-btn btn-color ui-green-button"></button>
									</div>
								</ng-template>
							</div>
						</p-card>
					</form>
				</div>
			</div>
		}
		<div class="p-relative img-container">
			<div style="height: 100%" @fadeAndSlideUp>
				<div class="card-right" style="margin-left: -1px">
					<img src="assets/img/smartyCube-login-image.png" />
				</div>
			</div>
		</div>
	</div>
</div>
